<span class="font-semibold">Search for {{ providerLabel }} by NPI:</span>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="grid grid-cols-12 gap-4 p-form-widget mt-1">
    <div class="col-span-12 flex items-start">
      <div class="field inline-flex mr-2">
        <label class="field-required">NPI:</label>
        <div class="p-field-value">
          <p-inputMask
            class="inline-block npi-search"
            data-test-id="npi-searcn-input"
            formControlName="npi"
            mask="9999999999"
            slotChar=""
            styleClass="w-full"
            placeholder="Enter the NPI"
            [autoClear]="false"
          />
          <errors-messages [control]="form.get('npi')"></errors-messages>
        </div>
      </div>
      <button
        pButton
        label="Search"
        icon="pi pi-search"
        iconPos="left"
        type="submit"
        data-test-id="npi-search-button"
        [disabled]="form.invalid">
      </button>
    </div>
  </div>
</form>
